import{a as appGlobalScript}from"./workbench-global-131447c5.js";var globalScripts=appGlobalScript;export{globalScripts as g};